// extracted by mini-css-extract-plugin
export default {"mantine-button-root":"EpD9x","mantineButtonRoot":"EpD9x","mantine-button-loader":"GYmVC","mantineButtonLoader":"GYmVC"};